import { render } from "./contact-form.vue?vue&type=template&id=317a762e&ts=true"
import script from "./contact-form.vue?vue&type=script&lang=ts"
export * from "./contact-form.vue?vue&type=script&lang=ts"

import "./contact-form.vue?vue&type=style&index=0&id=317a762e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__